// Whether the admin panel has gone live on EMS V2 (the in-house ticket backend).
//
//   REACT_APP_EMS_V2_ENABLED=true   -> go-live: one "Escalation Management" entry and the top bar
//                                      button open EMS V2 (/tools/escalation-v2); the old
//                                      Freshdesk-backed V1 routes redirect there
//   anything else (or not set)       -> V1 (Freshdesk tickets) and EMS V2 side by side, as before
//
// Off unless set to true, because Ops work V1's Freshdesk tickets until they are migrated, and a
// default that flips by environment would ship the switch with the next staging -> master merge.
// CRA inlines it at build time: go-live = set it to true for the prod build (.env.production) and
// redeploy; rolling back is the same line set to false.
export const EMS_V2_ENABLED = (process.env.REACT_APP_EMS_V2_ENABLED || '').trim().toLowerCase() === 'true'

/** Where the top bar's Escalation Management button goes in this build. */
export const ESCALATION_HOME = EMS_V2_ENABLED ? '/tools/escalation-v2' : '/tools/escalation'
